import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import H5 from './pages/H5';
import TokenScan from './pages/TokenScan';
import DappApi from './pages/DappApi';
import Header from './components/Header';
import Footer from './components/Footer';
import OperationManual from './pages/OperationManual';

// 自定义布局组件，用于控制是否显示 Header 和 Footer
const Layout = ({ children }) => {
  const location = useLocation();
  const hideHeaderFooter = location.pathname === '/h5'; // 在 /h5 路由下隐藏 Header 和 Footer

  return (
    <div style={{ backgroundColor: '#fff', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {!hideHeaderFooter && <Header />}
      <div style={{ flex: 1, position: 'relative' }}>
        {children}
        <OperationManual />
        <DappApi />
      </div>
      {!hideHeaderFooter && <Footer />}
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        {/* 使用 Layout 包裹需要 Header 和 Footer 的页面 */}
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/TokenScan" element={<TokenScan />} />
                <Route path="/dapp-api" element={<></>} />
                <Route path="/wallte-doc" element={<></>} />
              </Routes>
            </Layout>
          }
        />
        {/* H5 页面独立，不包含 Header 和 Footer */}
        <Route path="/h5" element={<H5 />} />
      </Routes>
    </Router>
  );
}

export default App;


